import { ViewEncapsulation, ChangeDetectionStrategy, Component, input } from '@angular/core';
import { VisualContentError } from '../VisualContentError';

@Component({
  selector: 'pbir-visual-content-error-display',
  templateUrl: './VisualContentErrorDisplay.component.html',
  styleUrl: './VisualContentErrorDisplay.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class VisualContentErrorDisplay {
  readonly error = input<VisualContentError>();
}
